import { render, staticRenderFns } from "./NotificationListingAdmin.vue?vue&type=template&id=b93cdbb2&scoped=true"
import script from "./NotificationListingAdmin.vue?vue&type=script&lang=js"
export * from "./NotificationListingAdmin.vue?vue&type=script&lang=js"
import style0 from "./NotificationListingAdmin.vue?vue&type=style&index=0&id=b93cdbb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93cdbb2",
  null
  
)

export default component.exports